export default __webpack_public_path__ + "f708490adb2134718b599da0a133a74c.png";